var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.7012,
    r: 36.5,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2297_7266)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 36.5,
    fill: "#133F7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0496 54.5587C10.6423 54.8815 6.19677 57.1144 4.6499 58.1905C5.05343 65.3531 12.2766 79.2547 37.9411 77.5599C63.6056 75.8651 68.8783 63.9408 68.3067 58.1905C66.4908 56.2737 58.2184 56.3746 55.3937 55.4666C53.134 54.7403 49.2063 50.5907 47.5249 48.6066L27.752 45.8828C26.1042 48.6403 21.4569 54.2359 16.0496 54.5587Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8647 54.1562V59.503L22.4045 60.0074L18.6718 64.0427L22.1018 73.3239",
    stroke: "#868686",
    strokeWidth: 1.50515
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4956 55.4141V60.1063L50.9559 60.6107L54.6885 64.646L51.2585 73.9271",
    stroke: "#868686",
    strokeWidth: 1.50515
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1392 48.2044L27.955 45.7832L44.7015 46.3885L47.5262 48.2044C47.459 50.9955 47.1429 57.5663 46.4165 61.5209C45.6902 65.4754 44.0962 72.3153 43.39 75.2409C38.2249 76.4514 32.0912 75.7453 29.67 75.2409C28.1366 72.4969 26.6772 56.0732 26.1392 48.2044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5478 55.2656H35.0169L33.6046 57.2833L35.6222 60.5115L31.5869 75.4421C34.6537 76.2492 39.5903 75.7784 41.6752 75.4421L38.0434 60.5115L40.1619 57.2833L38.5478 55.2656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2031 29.2382C22.2031 27.9469 23.0102 27.0188 23.4137 26.7161L26.0367 17.6367L45.2043 19.6544L48.5334 27.0188C48.8697 26.9515 49.6835 27.1197 50.2484 28.3302C50.9546 29.8435 50.2484 32.7691 49.9458 33.5761C49.6431 34.3832 48.6343 37.2079 47.7264 37.3088C47 37.3895 46.6839 36.9389 46.6167 36.7035C46.0114 38.6203 43.2875 46.2873 35.8222 46.2873C29.85 46.2873 26.8101 39.091 26.0367 35.4929C26.003 35.7619 25.8954 36.3807 25.734 36.7035C25.5322 37.107 24.7252 37.4097 23.9181 36.0982C23.1111 34.7867 22.2031 30.8523 22.2031 29.2382Z",
    fill: "#FCCFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8535 45.782V40.3343L45.1044 39.2246V46.8917C44.2166 49.2321 40.4302 53.0455 38.6479 54.6596H34.9153C33.5433 54.014 29.6358 48.4722 27.8535 45.782Z",
    fill: "#FCCFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0297 34.5846C47.949 36.1987 48.5342 35.2571 48.8368 34.5846C49.4422 33.4749 49.5428 30.9528 49.442 29.5404C49.3411 28.1281 48.1305 27.8254 47.8279 30.0449C47.5253 32.2643 48.5341 29.7422 48.635 32.0625C48.7358 34.3828 48.1306 32.5669 48.0297 34.5846Z",
    fill: "#FB9E82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7603 34.6861C24.841 36.3002 24.2559 35.3587 23.9532 34.6861C23.3478 33.5764 23.2472 31.0544 23.3481 29.642C23.449 28.2297 24.6595 27.927 24.9621 30.1464C25.2648 32.3658 24.256 29.8438 24.1551 32.1641C24.0542 34.4844 24.6594 32.6685 24.7603 34.6861Z",
    fill: "#FB9E82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7529 19.1497C26.2195 20.6831 25.7689 26.5814 25.7352 29.3388C24.9282 27.644 23.7848 27.0185 23.314 26.9176C22.507 24.4965 23.0114 17.2329 23.6167 16.325C24.222 15.417 26.5423 8.65793 37.034 9.36411C47.5258 10.0703 49.2408 17.132 49.2408 18.2418C49.2408 19.1295 49.4425 24.6646 49.4425 27.3212C48.232 27.4019 47.5931 28.6999 47.5258 29.3388L45.5082 21.3691C43.6519 20.4813 32.8979 19.5196 27.7529 19.1497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4285 46.2867C31.6669 46.2867 28.7278 42.3859 27.8535 40.4355C28.6606 43.9664 34.0073 48.0017 36.832 49.1114C39.0918 49.9992 42.2797 49.7504 43.5912 49.515L45.1044 46.6903V40.7382C44.1965 42.5877 41.1902 46.2867 36.4285 46.2867Z",
    fill: "#FB9E82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2297_7266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 36.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/userAvatar.5e5be255d9fff12ece2ad00630a09e18.svg";
export { ForwardRef as ReactComponent };